<template>
  <v-btn class="mr-2" icon color="error">
    <v-icon>
      mdi-close
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "CheckIcon"
};
</script>

<style scoped lang="scss">
button {
  background-color: #fbeaed;
  height: 28px !important;
  min-width: 28px !important;
}
</style>
